

import api from '../../../services/api/';

const URL = '/settings';

class SettingsService {

    getSettings(){
        return api.get(URL);
    }

    getSettingsByTag(tag){
        return api.get(URL + '/' + tag);
    }  

    getSettingsGroup( groupArray){
        return api.post(URL + '/group', { keys: groupArray });
    }

    getTimezones(){
        return api.get('/timezones');
    }

    updateSettings(id, settings){
        return api.put(URL + '/' + id, settings);
    }
    updateSettingsGroup(settings){
        return api.post(URL + '/group/update', settings);
    }

    getCustomFields(){
        return api.get( URL + '/sales/custom_fields');
    }

    updateCustomFields(customFields){
        return api.post( URL +'/sales/custom_fields', customFields);
    }

    getCustomerCustomFields(){
        return api.get( URL + '/customers/custom_fields');
    }

    updateCustomerCustomFields(customFields){
        return api.post( URL +'/customers/custom_fields', customFields);
    }

    getSaleStatusWorkflows(){
        return api.get( URL + '/sales/workflow_statuses');
    }

    addCustomStatus(statusData){
        return api.post( URL + '/sales/workflow/statuses/add', statusData);
    }

    updateStatus(statusId, statusData){
        return api.put( URL + '/sales/workflow/statuses/' + statusId, statusData);
    }

    removeCustomStatus(statusId){
        return api.delete( URL + '/sales/workflow/statuses/' + statusId);
    }

    reorderStatuses(statusOrders){
        return api.post( URL + '/sales/workflow/statuses/reorder', { status_orders: statusOrders });
    }

    addTransition(transitionData){
        return api.post( URL + '/sales/workflow/transitions/add', transitionData);
    }

    updateTransition(transitionId, transitionData){
        return api.put( URL + '/sales/workflow/transitions/' + transitionId, transitionData);
    }

    removeTransition(transitionId){
        return api.delete( URL + '/sales/workflow/transitions/' + transitionId);
    }

    // Notification Settings
    getNotificationSettings(){
        return api.get( URL + '/notifications');
    }

    updateNotificationSettings(notificationData){
        return api.post( URL + '/notifications', notificationData);
    }

    getNotificationEmails(){
        return api.get( URL + '/notifications/emails');
    }

    // Organization users available as notification recipients (settings-scoped picker)
    getNotificationRecipientUsers(){
        return api.get( URL + '/notifications/recipient_users');
    }

    checkNotificationStatus(notificationKey){
        return api.get( URL + '/notifications/check/' + notificationKey);
    }

    resetNotificationSettings(){
        return api.post( URL + '/notifications/reset');
    }

    // PDF template background image (sales/estimates)
    uploadPdfBackgroundImage(formData) {
        return api.post(URL + '/pdf_background_image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    deletePdfBackgroundImage() {
        return api.delete(URL + '/pdf_background_image');
    }

    getPdfBackgroundImagePreview(cacheKey = Date.now()) {
        return api.get(URL + '/pdf_background_image/preview', {
            responseType: 'blob',
            params: { _t: cacheKey },
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
        });
    }

}

export default new SettingsService();
